module.exports = __webpack_public_path__ + "img/unisal.41cf0286.png";